// import React, { ReactNode, useState } from 'react';
// import './style.scss';
// import { UnitInput, UnitInputPosition } from '../../../unitInput';
// import { UnitSelectorPosition } from '../../../unitSelector';
// // import { Button, ButtonFill, ButtonSize } from 'views/mutual/button';
// import { InputTemplate, InputTemplateDataProps } from '../../../inputTemplate';
// import { CheckInput, CheckInputDataProps } from '../../../checkInput';
// import { UnitSelector } from '../../../unitSelector';
// import { CommonData } from '../../../common';
// import { SelectorDataProps } from '../../../selector';
// import { MultiSelections, Direction } from 'views/mutual/inputRadio';
// // import { AddressInfo, useBankDetailsInput } from './hook';
// import { icons } from 'constants/icons';
// import { IconColor, IconSize, SvgIcon } from 'views/mutual/svgIcon';
// import { useMessageModal } from 'views/mutual/modal/messageModal/hooks';
// import { MessageModalButtonProps,  } from 'views/mutual/modal/messageModal';
// import { ModalBase, ModalBaseProps, ModalStyle } from 'views/mutual/modal/';
// import { Button, ButtonFill, ButtonSize, ButtonType } from 'views/mutual/button';
// import { ITExplanationModalStep, BankStepProps } from '../hooks';
// import { SelectBankType, useSelectBank, useSelectBranch } from './hooks';
// import { BankButton, Title, Selected, Message, BankButtonProps } from '../module';
// import { FormikProps } from 'formik';

import { Button, ButtonFill, ButtonSize, ButtonType } from 'views/mutual/button';
import { ITExplanationModalStep } from '../hooks';

type ElectronicDeliveryOfDisclosureDocumentProps = {
  setModalStep: (agreeType: number, step: ITExplanationModalStep) => void;
};

export const ElectronicDeliveryOfDisclosureDocument = ({
  setModalStep,
}: ElectronicDeliveryOfDisclosureDocumentProps) => {
  return (
    <div className="itExplanation-modal_electronicDeliveryOfDisclosureDocument">
      <div className="itExplanation-modal_electronicDeliveryOfDisclosureDocument_title">
        {'重要事項説明書の電子交付について'}
      </div>
      <div className="itExplanation-modal_electronicDeliveryOfDisclosureDocument_label">{`　重要事項説明書は、DocuSign, Inc.が提供する電子署名サービス（DocuSign eSignature）を利用して、当該書面の記載事項を記録した電子ファイルにアクセスするためのURLを記載した電子メールをお客様の指定アドレスに送信する電磁的方法により電子交付します。
　重要事項説明書の電子交付を受けるには、重要事項説明書のPDFファイルを閲覧し、また、同ファイルに付与される電子署名日時とその後の改変の有無を証明するタイムスタンプを適切に確認できる環境、具体的には、Adobe Acrobat Reader などのPDF閲覧ソフトウェアが必要となりますので、これをお持ちの場合のみ、電子交付に承諾いただくようお願いいたします。Adobe Acrobat Readerの場合、重要事項説明書ファイルを、Docusign eSignatureからダウンロードしてお客様のパソコンに保存いただいた上で、同ソフトウェアにてこれを閲覧してください。文字や画面のサイズから、スマートフォンでは重要事項説明書を見づらく、さらに、電子交付するファイルが改変されていないことの確認ができない可能性がありますので、パソコンを使用して閲覧してください。その際に画面上に表示される「署名パネル」に「文書は、この署名が適用されてから変更されていません」と表示される場合、同ファイルは電子署名の後に改変されていません。この電子署名の日時は、重要事項説明書ファイルとともに電子署名サービスからダウンロードできる完了証明書（Summary)に記載される署名の日時です。Adobe Acrobat Reader以外のPDF閲覧ソフトウェアの場合、タイムスタンプの確認方法が異なる可能性がありますので、「お問い合わせ」からご相談ください。
　電子交付への承諾後でも、FPGオンラインサービスの「お問い合わせ」から申し出ることで、電子交付に代えて書面の交付をご希望することができます。書面の交付をご希望される場合、オンライン取引による契約手続きを停止します。
　重要事項説明書をダウンロードされましたら、文字化け、文字欠けや解像度の関係で表がぼやけていないかなど、閲覧に問題ないことをご確認ください。
　ダウンロードされたファイルは、必要に応じてバックアップを取ったり、プリントアウトして併せて保管されることをお勧めします。
　改変有無の確認方法やファイルの保存方法等については、口頭でご説明することもできますので、FPGオンラインサービスの「お問い合わせ」からお申し出ください。ダウンロードされたファイルの閲覧に問題がある場合、電子交付を中止いたしますので、同様に「お問い合わせ」からお申し出ください。
　重要事項説明書は、IT重説の実施に先立ち、事前によくお読みいただきますようお願いいたします。
`}</div>
      <div className="itExplanation-modal_button">
        <Button
          type={ButtonType.Submit}
          label={'重要事項説明書の電子交付に承諾する'}
          buttonFill={ButtonFill.black}
          buttonSize={ButtonSize.small}
          onClick={() => {
            setModalStep(1, ITExplanationModalStep.IT_DISCLOSURE_VIA_WEB_CONFERENCE);
          }}
        />
      </div>
    </div>
  );
};
